import { render, staticRenderFns } from "./AdditionalPhone.vue?vue&type=template&id=0731a62c&scoped=true&"
import script from "./AdditionalPhone.vue?vue&type=script&lang=js&"
export * from "./AdditionalPhone.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalPhone.vue?vue&type=style&index=0&id=0731a62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0731a62c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0731a62c')) {
      api.createRecord('0731a62c', component.options)
    } else {
      api.reload('0731a62c', component.options)
    }
    module.hot.accept("./AdditionalPhone.vue?vue&type=template&id=0731a62c&scoped=true&", function () {
      api.rerender('0731a62c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/domains/profile/components/ProfileField/field-types/AdditionalPhone.vue"
export default component.exports